// Procedencia — ¿aplica garantía? (hoja "Procedencia" del xlsx).
// La IA/supervisor PROPONE; la inmobiliaria resuelve. Reducida de 9 a
// 4 estados en v2 (se eliminaron tramos de garantía, "fuera de plazo"
// y "dentro de tolerancia"). Regla dura (ADR-0129, reconciliación con
// ADR-0105): la procedencia JAMÁS dispara una transición de estado —
// el cierre sigue exclusivamente el grafo. PR-04 "En análisis" no es
// un cierre válido.
export const PROCEDENCIAS = [
    {
        codigo: "PR-01",
        nombre: "Procede — garantía",
        criterio: "Observación atribuible a ejecución, materiales o proyecto.",
        efecto: "Se repara sin costo.",
    },
    {
        codigo: "PR-02",
        nombre: "No procede",
        criterio: "Mal uso o intervención del propietario, falta de mantención, o desgaste normal por vida útil. El motivo específico va en texto libre obligatorio.",
        efecto: "Se informa al propietario con el motivo. NO cierra por sí sola: si corresponde un rechazo, usa la transición abierta→rechazada del grafo con el motivo citado en el comentario obligatorio (ADR-0129).",
    },
    {
        codigo: "PR-03",
        nombre: "Requiere peritaje",
        criterio: "Requiere ensayo o informe de especialista para determinar causa.",
        efecto: "Queda abierta a la espera del informe.",
    },
    {
        codigo: "PR-04",
        nombre: "En análisis",
        criterio: "Estado transitorio mientras la inmobiliaria resuelve.",
        efecto: "No es un cierre válido.",
    },
];
//# sourceMappingURL=procedencias.js.map